import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-300" data-id="element-75" data-mp="3gezdb400vr15">
      <div className="h-px w-full bg-amber-400/60" aria-hidden="true" data-id="element-76" data-mp="3ggu1qsai619z" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-77" data-mp="32ovwisjwwpj3">
        <p className="text-xs" data-id="element-78" data-mp="36pfufycb7x6a">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}